export default "/images/vendor/flag-icon-css/flags/4x3/py.svg?51b0bef3321042c047177de5e4f42e7c";